import React from 'react'
import { Link } from 'react-router-dom';


function ProfilePage({ userInfo }) {

    return (
        <>
            <div>
                {/* profile image */}
                <div className="imageDiv d-flex justify-content-center align-items-center" >
                    <img className='imageStyle' src={`/uploads/${userInfo.profileImage}`} alt="" />
                </div>
                {/* name */}
                <div className="name">
                    <p>{userInfo.name}</p>
                </div>
                {/* role */}
                <div className="name">
                    <p>{userInfo.role}</p>
                </div>
                {/* email */}
                <div className="name">
                    <p>{userInfo.email}</p>
                </div>
                <div className='float-right'>
                    <div className="btn-group">
                        <Link to={'/show-users'} className="btn btn-info">Dashboard</Link>
                        <Link to={`/update-user/${userInfo.id}`} className="btn btn-primary">Update Info</Link>
                        <Link to={`/update-password/${userInfo.id}`} className="btn btn-warning">Change PassWord</Link>
                    </div>
                </div>
            </div>
            {/* you have these routes permissions : a list */}
            <div className="permissions">
                <h3>You have these routes permission</h3>
                <table className="table table-bordered ">
                    <thead>
                        <tr>
                            <th style={{ width: '10px' }}>#</th>
                            <th>Routes Url</th>
                        </tr>
                    </thead>
                    <tbody>
                        {Object.keys(userInfo).length > 0 && userInfo.permissions.map((item, index) => (
                            <tr key={item}>
                                <td>{index + 1}</td>
                                <td>{item}</td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        </>

    )
}

export default ProfilePage
